import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICarrierAreaResponseDTO, IUpdateCarrierAreaRequestDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateCarrierAreaCommand
    extends IRequestCommand<
    IUpdateCarrierAreaRequestDTO,
    ErrorDetails,
    IUpdateCarrierAreaRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.PUT;

    public override setParameters(parameters: IUpdateCarrierAreaRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.urlSections.push(`${parameters.areaId}`);
        this.composeUrl();
    }
}

export interface IUpdateCarrierAreaRequest extends ICommandParameters,ICarrierAreaResponseDTO {
  carrierId: number;
}
